import { render } from "./ProductClientProfile.vue?vue&type=template&id=5ffa7d55&scoped=true"
import script from "./ProductClientProfile.vue?vue&type=script&lang=js"
export * from "./ProductClientProfile.vue?vue&type=script&lang=js"

import "./ProductClientProfile.vue?vue&type=style&index=0&id=5ffa7d55&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffa7d55"]])

export default __exports__